import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  heroUserPlus,
  heroUsers,
  heroEye,
  heroCheckCircle,
  heroXCircle,
  heroClock,
  heroBuildingOffice,
} from '@ng-icons/heroicons/outline';
import { UserAvatarComponent } from '../../../shared/user-avatar/user-avatar.component';
import { TimeAgoPipe } from '../../../core/pipes/timeAgo.pipe';
import { UserRequest } from '../../../models/user-request.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-user-requests-preview',
  standalone: true,
  imports: [
    CommonModule,
    NgIcon,
    MatButtonModule,
    MatTooltipModule,
    UserAvatarComponent,
    TimeAgoPipe
  ],
  providers: [
    provideIcons({
      heroUserPlus,
      heroUsers,
      heroEye,
      heroCheckCircle,
      heroXCircle,
      heroClock,
      heroBuildingOffice
    })
  ],
  templateUrl: './user-requests-preview.component.html',
  styleUrl: './user-requests-preview.component.scss'
})
export class UserRequestsPreviewComponent {
  @Input() requests = signal<UserRequest[]>([]);
  @Output() viewAllRequests = new EventEmitter<void>();
  @Output() acceptRequest = new EventEmitter<UserRequest>();
  @Output() rejectRequest = new EventEmitter<UserRequest>();

  profileApiUrl = environment.profileApiUrl;
  displayedRequests = signal<UserRequest[]>([]);
  totalRequests = signal<number>(0);
  acceptingRequest = false;
  rejectingRequest = false;
  ngOnInit() {
    this.displayedRequests.set(this.requests().slice(0, 2));
    this.totalRequests.set(this.requests().length);
  }

  ngOnChanges() {
    this.displayedRequests.set(this.requests().slice(0, 2));
    this.totalRequests.set(this.requests().length);
  }

  onViewAll() {
    this.viewAllRequests.emit();
  }

  onAcceptRequest(request: UserRequest) {
    this.acceptingRequest = true;
    this.acceptRequest.emit(request);
  }

  onRejectRequest(request: UserRequest) {
    this.rejectingRequest = true;
    this.rejectRequest.emit(request);
  }

  onRequestAccepted() {
    this.acceptingRequest = false;
  }

  onRequestRejected() {
    this.rejectingRequest = false;
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'pending': return 'heroClock';
      case 'accepted': return 'heroCheckCircle';
      case 'rejected': return 'heroXCircle';
      default: return 'heroClock';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'pending': return 'Pending';
      case 'accepted': return 'Connected';
      case 'rejected': return 'Declined';
      default: return 'Unknown';
    }
  }
}